import { Button } from '@ui/kit';
import { SkipIcon } from '@ui/kit/icons';
import { useSkipCurrentTaskAction } from '../../../state/actions/task.skip.js';
import { jsx } from 'react/jsx-runtime';

function SkipButton(props) {
  const handleSkip = useSkipCurrentTaskAction();
  return /*#__PURE__*/jsx(Button, {
    theme: "secondary",
    disabled: props.disabled,
    onClick: handleSkip,
    icon: {
      position: "after",
      content: /*#__PURE__*/jsx(SkipIcon, {
        height: 10
      })
    },
    children: "Spring over"
  });
}

export { SkipButton };
//# sourceMappingURL=button.skip.js.map
